/**
 * Deployed DEVELOP environment (Firebase project `ota-develop`).
 *
 * Used by `ng build --configuration develop` (yarn build:dev), which the
 * `firebase-hosting-merge`/`pull-request` workflows run on push/PR to `develop`.
 *
 * Unlike `environment.ts` (local dev → http://localhost:3000), this points at
 * the deployed develop backend so the hosted site actually works.
 *
 * TODO(confirm): `apiBase` assumes OTA's develop backend is the shared
 * property-manager-backend develop host (`https://api-develop.property.guestgenie.com`,
 * same one property-manager-ui targets). Adjust if OTA has its own develop host.
 */
export const environment = {
  production: false,
  /** property-manager-backend develop base. */
  apiBase: 'https://api-develop.property.guestgenie.com',
  /** Public OTA marketplace API (no auth). */
  otaPath: '/api/v1/ota',
  /**
   * Google Maps JavaScript browser key. Reuses the dev key — make sure the
   * deployed develop domain (e.g. ota-develop.web.app) is whitelisted in the
   * key's HTTP referrer restrictions in Google Cloud console.
   */
  googleMapsApiKey: 'AIzaSyBP6MAtogUrBirr7cQ24kFQNPhgBZbnCFE',
  /** Stripe publishable key (test mode) for direct-booking PaymentIntents. */
  stripePublishableKey: 'pk_test_51PBGEl2LuUb40Y0z2rNQEknV4ZOmezcHc4uX6pqfiPA96131gPlLpSqAtyoNdRcgyC4yMfo4BFmtGyecSVgSA7qf00Dgt5HNtq',
  /** GuestGenie guest app base — deep link for booked-stay add-on services. */
  guestAppBase: 'https://develop.app.guestgenie.com',
  /**
   * guest-genie Firebase web config (project `guestgenie-develop`). OTA guests
   * ARE guest-genie users: the client signs in here and sends the Firebase ID
   * token to PM, which introspects it against guest-genie.
   */
  firebase: {
    apiKey: 'AIzaSyBHy0Nk44hId48eD0NeqcuPcKrtB_LHR0E',
    authDomain: 'guestgenie-develop.firebaseapp.com',
    projectId: 'guestgenie-develop',
    storageBucket: 'guestgenie-develop.appspot.com',
    messagingSenderId: '226788270369',
    appId: '1:226788270369:web:7e0feaf2e025efb07c1e60',
  },
  /** Legacy manual JWT override; kept only as a dev escape hatch. */
  devJwt: '',
  /** Serve local mock catalog instead of the backend (offline demo). */
  useMockData: false,
  /** Dev-only escape hatch for synthetic backend orders when Stripe is unavailable. */
  simulatePayment: false,
};
